import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import humanTime from 'flarum/common/helpers/humanTime';
import username from 'flarum/common/helpers/username';
import tagIcon from 'ext:flarum/tags/common/helpers/tagIcon';
import ActivityFeed from './ActivityFeed';
import NhBanner from './NhBanner';
const INCLUDE = 'forums,forums.children,forums.lastPostedDiscussion,forums.lastPostedDiscussion.lastPostedUser';
export default class ForumsPage extends Page {
  loading = true;
  blocks = [];
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('nh.forums', app.translator.trans('neverhack-forum-nodes.lib.forums'));
    app.setTitle(String(app.translator.trans('neverhack-forum-nodes.forum.page.title')));
    app.setTitleCount(0);
    const preloaded = app.preloadedApiDocument();
    if (preloaded) {
      this.blocks = preloaded;
      this.loading = false;
    } else {
      app.store.find('nh-blocks', {
        include: INCLUDE
      }).then(blocks => {
        this.blocks = blocks;
        this.loading = false;
        m.redraw();
      });
    }
  }
  view() {
    return m(PageStructure, {
      className: "IndexPage NhForumsPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: this.loading
    }, m(NhBanner, null), m(ActivityFeed, null), m("div", {
      className: "NhForums"
    }, this.blocks.length === 0 ? m("p", {
      className: "NhForums-empty"
    }, app.translator.trans('neverhack-forum-nodes.forum.empty')) : this.blocks.map(block => this.blockView(block))));
  }
  hero() {
    return m(WelcomeHero, null);
  }
  sidebar() {
    return m(IndexSidebar, null);
  }
  blockView(block) {
    const forums = (block.forums() || []).filter(Boolean);
    const color = block.color() || '';
    return m("section", {
      className: "NhBlock",
      style: color ? {
        '--nh-block-color': color
      } : undefined,
      key: block.id()
    }, m("header", {
      className: "NhBlock-header"
    }, block.icon() && m(Icon, {
      name: block.icon(),
      className: "NhBlock-icon"
    }), m("h2", {
      className: "NhBlock-title"
    }, block.name()), block.description() && m("p", {
      className: "NhBlock-description"
    }, block.description())), m("div", {
      className: "NhBlock-body"
    }, forums.length === 0 ? m("div", {
      className: "NhForum NhForum--empty"
    }, app.translator.trans('neverhack-forum-nodes.forum.empty')) : forums.map(forum => this.forumView(forum))));
  }
  forumView(forum) {
    const children = (forum.children() || []).filter(Boolean);
    const last = forum.lastPostedDiscussion();
    const topics = forum.attribute('nhDiscussionCount') ?? forum.discussionCount() ?? 0;
    const posts = forum.attribute('nhPostCount') ?? 0;
    return m("div", {
      className: "NhForum",
      key: forum.id()
    }, m("div", {
      className: "NhForum-icon"
    }, tagIcon(forum, {
      className: 'NhForum-iconInner'
    })), m("div", {
      className: "NhForum-main"
    }, m("h3", {
      className: "NhForum-title"
    }, m(Link, {
      href: app.route('tag', {
        tags: forum.slug()
      })
    }, forum.name())), forum.description() && m("p", {
      className: "NhForum-description"
    }, forum.description()), m("div", {
      className: "NhForum-stats"
    }, m("span", {
      className: "NhForum-stat"
    }, app.translator.trans('neverhack-forum-nodes.forum.stats.topics', {
      count: this.fmt(topics)
    })), m("span", {
      className: "NhForum-stat"
    }, app.translator.trans('neverhack-forum-nodes.forum.stats.posts', {
      count: this.fmt(posts)
    }))), children.length > 0 && m("ul", {
      className: "NhForum-children"
    }, children.map(child => m("li", {
      key: child.id()
    }, m(Link, {
      href: app.route('tag', {
        tags: child.slug()
      }),
      className: "NhForum-child"
    }, m(Icon, {
      name: child.icon() || 'far fa-comments',
      className: "NhForum-childIcon"
    }), m("span", null, child.name())))))), m("div", {
      className: "NhForum-last"
    }, last ? m('[', null, m(Link, {
      className: "NhForum-lastTitle",
      href: app.route('discussion', {
        id: last.slug(),
        near: last.lastPostNumber() || undefined
      })
    }, last.title()), m("div", {
      className: "NhForum-lastMeta"
    }, humanTime(last.lastPostedAt() || last.createdAt()), last.lastPostedUser() && m('[', null, ' · ', m(Link, {
      href: app.route.user(last.lastPostedUser())
    }, username(last.lastPostedUser()))))) : m("span", {
      className: "NhForum-lastEmpty"
    }, app.translator.trans('neverhack-forum-nodes.forum.no_posts'))));
  }
  fmt(n) {
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    return String(n);
  }
}
flarum.reg.add('neverhack-forum-nodes', 'forum/components/ForumsPage', ForumsPage);